import React, { useMemo } from 'react'

import { useExchangeDataContext } from '@src/pages/Exchange/context/ExchangeDataContext'

export function JupiterRouteDetails() {
    const { quoteResponse, openJupiterRouteModal } = useExchangeDataContext()
    const quoteData = quoteResponse?.quote

    // No longer need the getTokenSymbol function since it's moved to the modal component

    const jupiterQuote = useMemo(() => {
        if (!quoteData?.jupiter_quote) return null
        return quoteData.jupiter_quote
    }, [quoteData])

    const slippagePercentage = useMemo(() => {
        if (!jupiterQuote?.slippageBps) return null
        // Convert basis points to percentage (1 bp = 0.01%)
        return (jupiterQuote.slippageBps / 100).toFixed(2)
    }, [jupiterQuote])

    if (!jupiterQuote || !jupiterQuote.routePlan || jupiterQuote.routePlan.length === 0) {
        return null
    }

    return (
        <div className='mt-1 flex flex-col gap-2 border-t border-mach-gray pt-3'>
            {/* Always show price impact first if available */}
            {jupiterQuote?.priceImpactPct && (
                <div className='mb-1 flex items-center justify-between'>
                    <span className='text-fluid-sm font-medium text-mach-sub-text'>Price Impact</span>
                    <span className='rounded-md bg-mach-gray px-2 py-1 text-fluid-sm text-white'>
                        {parseFloat(jupiterQuote.priceImpactPct) < 0.0001
                            ? '<0.01%'
                            : `${(parseFloat(jupiterQuote.priceImpactPct) * 100).toFixed(2)}%`}
                    </span>
                </div>
            )}

            <div className='mb-1 flex items-center justify-between'>
                <span className='text-fluid-sm font-medium text-mach-sub-text'>Slippage Tolerance</span>
                <span className='rounded-md bg-mach-gray px-2 py-1 text-fluid-sm text-white'>
                    {slippagePercentage}%
                </span>
            </div>

            <div className='flex flex-col gap-1'>
                {/* Minimized route display - single line with just AMMs */}
                <div
                    className='flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 transition-colors duration-200 hover:bg-mach-surface-background'
                    onClick={openJupiterRouteModal}
                >
                    {/* AMM pills in a row */}
                    {jupiterQuote.routePlan.map((route, index) => (
                        <React.Fragment key={`route-${index}`}>
                            {index > 0 && <div className='text-mach-sub-text'>→</div>}

                            <div className='rounded-full border border-mach-green bg-mach-surface-background px-3 py-1'>
                                <span className='text-fluid-xs font-medium text-white'>{route.swapInfo.label}</span>
                            </div>
                        </React.Fragment>
                    ))}

                    {/* View details icon */}
                    <div className='hover:text-mach-green-light ml-auto text-mach-green'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            className='h-4 w-4'
                            fill='none'
                            viewBox='0 0 24 24'
                            stroke='currentColor'
                        >
                            <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
                            />
                            <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z'
                            />
                        </svg>
                    </div>
                </div>
            </div>

            {/* Modal is now rendered at the Exchange page level */}
        </div>
    )
}
